export default __webpack_public_path__ + "static/Carriage House Club - Rules & Regulations-1a4a44fe58d6b8cfab2f23f603e6932e.pdf";